<template>
  <div class="mb-about">
    <div class="mb-about-close">
      <div @click="mbClose"><svg t="1634543249843" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13566" width="16" height="16"><path d="M683.480334 939.297259a36.859118 36.859118 0 0 1-25.874613-11.716806L241.170918 512.61025 657.605721 95.443147A36.615018 36.615018 0 1 1 709.354946 146.460072L344.669368 512.61025l364.685578 363.953278A36.859118 36.859118 0 0 1 683.480334 939.297259z" fill="#ffffff" p-id="13567"></path></svg><span>返回</span></div>
    </div>
    <div class="mb-about-company">
      <div class="mb-about-company-title">
        <div>
          <template v-if="companyLogo">
            <img :src="companyLogo">
          </template>
          <template v-else>
            <img src="../assets/images/list_logo.png">
          </template>
        </div>
        <div>
          <h4>{{companyName}}</h4>
          <p>来源：{{schoolName}}</p>
        </div>
        <div>
          <button @click="applyItem(expkid,teachinStatus)" :class="{isOver:teachinStatus=='已结束'}">{{teachinStatus?teachinStatus:"报名"}}</button>
        </div>
      </div>
      <div class="mb-about-company-held">
        <div><svg t="1634545284404" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14497" width="16" height="16"><path d="M512 64c-256 0-460.8 208-460.8 460.8s208 460.8 460.8 460.8 460.8-208 460.8-460.8S768 64 512 64zM512 940.8c-227.2 0-412.8-185.6-412.8-412.8s185.6-412.8 412.8-412.8 412.8 185.6 412.8 412.8S742.4 940.8 512 940.8z" p-id="14498" fill="#8a8a8a"></path><path d="M809.6 544l-278.4 0 0-281.6c0-12.8-9.6-22.4-22.4-22.4-12.8 0-22.4 9.6-22.4 22.4l0 307.2c0 12.8 9.6 22.4 22.4 22.4 0 0 3.2 0 3.2 0l297.6 0c12.8 0 22.4-9.6 22.4-22.4C832 553.6 822.4 544 809.6 544z" p-id="14499" fill="#8a8a8a"></path></svg><span>举办时间：2021-10-18 09:00:00</span></div>
        <div><svg t="1634545416116" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15611" width="16" height="16"><path d="M512.978 12.556a0.956 0.956 0 1 0-1.911 0 0.957 0.957 0 0 0 1.911 0zM511.712 38.034c-218.895 0-397.087 182.99-397.087 407.842 0 273.163 362.508 535.242 377.894 545.664a33.09 33.09 0 0 0 38.384 0c15.39-10.422 377.893-272.5 377.893-545.664 0-224.852-178.19-407.842-397.084-407.842z m0 885.174c-73.295-56.753-330.906-270.845-330.906-477.333 0-188.453 148.905-341.662 330.906-341.662s330.905 153.21 330.905 341.662c0 206.154-257.61 420.58-330.905 477.333z" p-id="15612" fill="#8a8a8a"></path><path d="M511.712 268.678c-72.024-1.682-137.895 40.41-166.63 106.472-28.736 66.066-14.614 142.95 35.723 194.487 50.335 51.54 126.867 67.476 193.59 40.304 66.727-27.162 110.364-92.024 110.383-164.067 1.01-96.665-76.4-175.93-173.066-177.196z m0 288.213c-45.242 1.692-86.974-24.266-105.47-65.588-18.494-41.323-10.041-89.735 21.354-122.348 31.4-32.612 79.46-42.898 121.455-25.984 41.995 16.913 69.512 57.631 69.542 102.904 0.924 60.062-46.83 109.587-106.881 110.854v0.162z" p-id="15613" fill="#8a8a8a"></path></svg><span>举办地点：大学生活动中心A205</span></div>
      </div>
      <div class="mb-about-company-content">
        <div class="mb-about-company-content-change">
          <span @click="propaganda(0)" :class="[{current:toggle_key==0}]">宣传正文</span><span @click="propaganda(1)" :class="[{current:toggle_key==1}]">公司其他宣讲</span>
        </div>
        <div class="mb-about-company-content-text">
          <keep-alive>
            <component :is="currentTabComponent" :list="anotherTeachinList" :info="companyIntroduction" @outputSchoolId="applyItem"></component>
          </keep-alive>
        </div>
      </div>
    </div>

    <Dialog :dialog_toggle.sync="dialog" width="85%">
        <template v-slot:title>
          <div class="mb-dialog-title"><img src="../assets/images/logo.png"><span>快速报名</span></div>
        </template>
        <ApplyForm :select_expkid="expkid" @close="closeApply"></ApplyForm>
    </Dialog>
  </div>
</template>

<script>
import Lists from "@/components/Lists.vue"
import wjText from "@/components/Text.vue"
import Dialog from "@/components/JobDialog.vue"
import ApplyForm from "@/components/ApplyForm.vue"
export default {
  name:"MBAbout",
  data(){
    return{
      toggle_key:0,
      currentTabComponent:"wjText",
      companyName:"",
      schoolName:"",
      startTime:"",
      holdPosition:"",
      anotherTeachinList:[],
      companyLogo:"",
      companyIntroduction:"",
      teachinStatus:"",

    }
  },
  components:{Lists,wjText,ApplyForm,Dialog},
  created(){
    this.requestData()
  },
  methods:{
    closeApply(e){
      this.dialog=false;
    },
    mbClose(){
      this.$router.go(-1)
    },
    propaganda(key){
      let componentBox=["wjText","Lists"];
      this.toggle_key=key;
      this.currentTabComponent=componentBox[key]
    },
    requestData(){
      this.rq.post(`/Detail/GetExecutiveDetail${window.location.search}`).then(res=>{
          let {SchoolName,CMPName,CMPIntroduction,ExList,ExDate,ExAddTime,ExSpaName,CMPLogo,ExPKID,ExStatus}=res.Data;
          this.publishTime=ExAddTime;
          this.startTime=ExDate;
          this.schoolName=SchoolName;
          this.companyName=CMPName;
          this.holdPosition=ExSpaName;
          this.companyIntroduction=CMPIntroduction||"该企业暂未填写相关信息";
          this.anotherTeachinList=ExList;
          this.companyLogo=CMPLogo;
          this.expkid=ExPKID;
          this.teachinStatus=ExStatus;
      },err=>{
          console.log(err)
      })
    }
  }

}
</script>

<style scoped lang="less">
*{
    -webkit-overflow-scrolling: touch;
}
.isOver{
  background: #ccc !important;
  letter-spacing: 0 !important;
}
.mb-about{
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-overflow-scrolling: auto;
    padding-top: 2.5rem;
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    button{
      border: none;
      border: none;
    }
    
    &-close{
      height: 2.5rem;
      background: #2b3d5e;
      font-size: 0.9rem;
      text-align: left;
      display: flex;
      align-items: center;
      color: #fff;
      padding-left: 8px;
      position: fixed;
      top: 0;left: 0;right: 0;
      z-index: 999;
      &>div{
        display: inline-flex;
        align-items: center;
        &>span{
          display: inline-flex;
          align-items: center;
          margin-left: 4px;
        }
      }
    }

    &-company{
      flex: 1 1;
      overflow: auto;
      background: #f6f6f6;
      &>div{
        background: #fff;
      }
      &-title{
        height: 5rem;
        background: #2b3d5e !important;
        display: flex;

        &>div:first-child{
          width: 5.2rem;
          img{
            width: 100%;
            height: 100%;
            transform: scale(0.75);
            border-radius: 8px;
          }
        }
        &>div:nth-child(2){
          flex: 1 1;
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          h4{
            font-size: 0.97rem;
            margin-bottom: 0.8rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: calc(100vw - 10.7rem);
            text-align: left;
            font-weight: 500;
          }
          p{
            color: rgba(255,255,255,0.8);
            text-align: left;
          }
        }
        &>div:last-child{
          width: 5.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          button{
            background: #ff6000;
            padding: 5px 15px;
            color: #fff;
            letter-spacing: 5px;
            border-radius: 5px;
          }
        }
      }
      &-held{
        height: 4rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 12px;
        &>div{
          text-align: left;
          margin: 2px 12px;
          display: flex;
          align-items: center;
          &>span{
            margin-left: 3px;
          }
        }
      }
      &-content{
        &-change{
          height: 3rem;
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0 25px;
          position: relative;
          &::before{
            content: "";
            position: absolute;
            bottom: 0;left: 0;right: 0;
            height: 1px;
            background: #ccc;
            transform: scaleY(0.5);
          }

          .current{
            color: #00a5ff;
            border-bottom: 2px solid #00a5ff;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }
        }
      }
    }
}
.mb-dialog-title{
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #ff8421;
  img{
    width: 75px;
    height: 28px;
    margin-right: 8px;
  }
}

</style>